export default "__VITE_ASSET__CM3W$qoa__"